import React, { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { productsLowPriceAlertsDashboardAccessControl } from '../access-control/viewAccess.configuration'

const LowPriceAlertsDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LowPriceAlertsDashboardPage" */
      '../pages/low-price-alert/LowPriceAlertsDashboardPage'
    )
)

export const productsPartnerScopedRouter = (
  <DomainRoute route="products-partner-scoped">
    <DashSwitch>
      <DomainRoute
        exact
        route="products-low-price-alerts-dashboard"
        tool="products-dashboard-tool"
        component={LowPriceAlertsDashboardPage as ComponentType<any>}
        accessControl={productsLowPriceAlertsDashboardAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
